export default __webpack_public_path__ + "static/media/pattern-bg.7f46e67e.svg";